var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TopicTemplate',{attrs:{"name":_vm.name,"topicImage":_vm.topicImage,"title":_vm.title,"appointment":_vm.appointment,"summary":_vm.summary,"content":_vm.content,"result":_vm.result,"selected":_vm.selected}})}
var staticRenderFns = []

export { render, staticRenderFns }